import { encodeWithSalt, DEFAULT_SALT } from './uuidEncoder';
import { loginUuidApi } from '../API/ApiService';
import { setSecureCookie } from './cookieUtils';

export const handleUuidAfterLogin = async (userUuid, userObj) => {
  try {
    if (!userUuid) {
      console.warn('No user_uuid provided for encoding');
      return null;
    }

    // Encode the UUID with salt
    const encodedUuid = encodeWithSalt(userUuid, DEFAULT_SALT);
    console.log('UUID encoded successfully:', { userUuid, encodedUuid });

    // Save the token in cookies immediately
    setSecureCookie('token', encodedUuid);
    console.log('UUID encoded and stored in cookie immediately');

    // Save the user object as a cookie (JSON stringified)
    if (userObj) {
      setSecureCookie('user', encodeURIComponent(JSON.stringify(userObj)));
      console.log('User object stored in cookie');
    }
    
    // Make API call to /api/login-uuid
    const response = await loginUuidApi({
      key: encodedUuid
    });
    
    // If API call is successful, you may handle response if needed
    if (response && response.data) {
      console.log('login-uuid API call successful');
      return response;
    } else {
      console.warn('API call to /api/login-uuid failed or returned no data');
      return null;
    }
    
  } catch (error) {
    console.error('Error handling UUID after login:', error);
    // Don't throw the error to avoid breaking the login flow
    return null;
  }
}; 